import { useState } from "react";
import Banner from "../../components/Banner/Banner";
import BannerBottom from "../../components/Banner/BannerBottom";
import BestSellers from "../../components/home/BestSellers/BestSellers";
import Cereal from "../../components/home/Cereal/Cereal";
import Sale from "../../components/home/Sale/Sale";
import SpecialOffers from "../../components/home/SpecialOffers/SpecialOffers";
import Processfood from "../../components/home/Processfood/Processfood";
import YearProduct from "../../components/home/YearProduct/YearProduct";
import { Helmet } from "react-helmet";
import { currentSales } from "../../constants";
import Spices from "../../components/home/Spices/Spices";

const Home = () => {
  const [showPopup, setShowPopup] = useState(true);

  return (
    <div className="w-full mx-auto">
      <Helmet>
        <meta charSet="utf-8" />
        <title>RK Global Trader | Certified Exporter from India | Import & Export Solutions</title>

        {/* SEO Optimized Meta Tags */}
        <meta
          name="description"
          content="RK Global Trader is a trusted Indian export company specializing in premium agriculture products, spices, cereals, processed food, and global trading solutions. 100% genuine exporter with transparent trade practices and reliable international shipping."
        />

        <meta
          name="keywords"
          content="Indian exporter, RK Global Trader, certified export company, agriculture export India, spices export India, bulk food export, international trading company, import export business, global supply chain, reliable exporter, farm products export, high quality export goods"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="RK Global Trader - Exporter from India" />

        {/* Fix broken canonical attribute */}
        <link rel="canonical" href="https://www.rkglobaltrader.com/" />

        {/* Open Graph for Social Media Ranking */}
        <meta property="og:title" content="RK Global Trader - India's Trusted Export Company" />
        <meta
          property="og:description"
          content="Exporting premium agriculture and food products worldwide with quality assurance and transparent trade practices."
        />
        <meta property="og:url" content="https://www.rkglobaltrader.com/" />
        <meta property="og:type" content="website" />
      </Helmet>

      {/* Popup Modal */}
      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 p-4">
          <div className="bg-white rounded-2xl p-6 max-w-md text-center shadow-xl">
            <h2 className="text-xl font-semibold mb-3 text-red-600">Important Notice</h2>
            <p className="text-sm leading-relaxed mb-4">
              We operate only in Import & Export and do not do domestic trade.<br /><br />
              If anyone asks for advance payment, stay away – it's not us.<br /><br />
              <strong>Official Contact:</strong><br />
              +91-9860968617<br />
              rkglobaltrader2023@gmail.com<br /><br />
              We do not sell any product in India. Stay safe from fraud.
            </p>
            <button
              onClick={() => setShowPopup(false)}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
            >
              OK
            </button>
          </div>
        </div>
      )}

      <Banner />
      <BannerBottom />

      <div className="max-w-container mx-auto px-4">
        <Spices />
        <Sale currentSales={currentSales} />
        <BestSellers />
        <YearProduct />
        <SpecialOffers />
        <Cereal />
        <Processfood />
      </div>
    </div>
  );
};

export default Home;
